if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();
        this.form = this.querySelector('form');
        this.form.querySelector('[name=id]').disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        // Check if this is a mystery bundle product
        if (this.isMysteryBundle()) {
          console.log('🎁 Mystery bundle detected - intercepting form submission');
          this.handleMysteryBundleSubmit();
          return;
        }

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButton.querySelector('span').classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: response,
              });
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    this.cart.renderContents(response);
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              this.cart.renderContents(response);
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading__spinner').classList.add('hidden');
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      /**
       * Check if current product is a mystery bundle
       * @returns {boolean} True if this is a mystery bundle product
       */
      isMysteryBundle() {
        // Find the closest section to this specific form
        const productSection = this.form.closest('[data-section]');
        // Check if THIS section is a mystery bundle
        const mysteryBundleSection = productSection?.querySelector('[data-mystery-bundle="true"]');
        const isMystery = !!mysteryBundleSection;
        console.log('🔍 Mystery bundle check for this form:', isMystery, 'Section:', productSection?.dataset?.section);
        return isMystery;
      }

      /**
       * Handle mystery bundle form submission
       */
      async handleMysteryBundleSubmit() {
        // Find the mystery bundle section relative to this form
        const productSection = this.form.closest('[data-section]');
        const mysteryBundleSection = productSection?.querySelector('[data-mystery-bundle="true"]');
        
        if (!mysteryBundleSection) {
          console.error('Mystery bundle section not found for this form');
          return;
        }

        const productId = parseInt(mysteryBundleSection.dataset.productId);
        
        // Try to find quantity input in various ways
        let quantityInput = this.form.querySelector('[name="quantity"]');
        if (!quantityInput) {
          quantityInput = this.form.querySelector('input[type="number"]');
        }
        if (!quantityInput) {
          quantityInput = document.querySelector('[name="quantity"]');
        }
        
        const quantity = quantityInput ? parseInt(quantityInput.value) || 1 : 1;
        
        console.log('📊 Mystery bundle params:', { productId, quantity, foundQuantityInput: !!quantityInput });

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');

        try {
          // Use the mystery bundle selector to handle the addition
          if (!window.mysteryBundleSelector) {
            throw new Error('Mystery bundle selector not initialized');
          }

          const result = await window.mysteryBundleSelector.handleMysteryBundleAdd(productId, quantity, this.cart);
          const { selectedVariants, cartResponse } = result;
          
          // Handle response same as normal product form
          if (cartResponse.status) {
            publish(PUB_SUB_EVENTS.cartError, {
              source: 'product-form',
              productVariantId: selectedVariants[0]?.id,
              errors: cartResponse.errors || cartResponse.description,
              message: cartResponse.message,
            });
            this.handleErrorMessage(cartResponse.description);
            this.error = true;
            return;
          } else if (!this.cart) {
            window.location = window.routes.cart_url;
            return;
          }

          // Publish cart update event (triggers cart drawer opening)
          if (!this.error) {
            publish(PUB_SUB_EVENTS.cartUpdate, {
              source: 'product-form',
              productVariantId: selectedVariants[0]?.id,
              cartData: cartResponse,
            });
          }

          // Render cart contents (opens cart drawer)
          if (this.cart) {
            this.cart.renderContents(cartResponse);
          }

          this.error = false;

        } catch (error) {
          console.error('Mystery bundle submission error:', error);
          
          // Show error message to user
          window.mysteryBundleSelector.showErrorMessage(
            error.message || 'Failed to add mystery bundle to cart', 
            mysteryBundleSection
          );

          this.error = true;
        } finally {
          this.submitButton.classList.remove('loading');
          if (this.cart && this.cart.classList.contains('is-empty')) {
            this.cart.classList.remove('is-empty');
          }
          if (!this.error) {
            this.submitButton.removeAttribute('aria-disabled');
          }
          this.querySelector('.loading__spinner').classList.add('hidden');
        }
      }
    }
  );
}
